import { render, staticRenderFns } from "./ExtensionGPW.vue?vue&type=template&id=39e10a7d&scoped=true&"
import script from "./ExtensionGPW.vue?vue&type=script&lang=js&"
export * from "./ExtensionGPW.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionGPW.vue?vue&type=style&index=0&id=39e10a7d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e10a7d",
  null
  
)

export default component.exports